import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { updateAgencySection } from "../../api/apiAgencySection";
import parseError from "../../utils/parseError";

export const useUpdateAgencySection = () => {
    const queryClient = useQueryClient();
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || "en").startsWith("ar");

    const mutation = useMutation({
        mutationFn: (data) => updateAgencySection(data),
        onSuccess: (response) => {
            queryClient.invalidateQueries({ queryKey: ["agency-section"] });
            toast.success(
                response?.message ||
                (isArabic ? "تم تحديث بيانات الوكالات" : "Agency section updated")
            );
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || (isArabic ? "تعذر التحديث" : "Failed to update"));
        },
    });

    return mutation;
};
